
import React from 'react';
import { Link } from 'react-router-dom';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
}

const Logo: React.FC<LogoProps> = ({ size = 'md' }) => {
  // Adjusted sizes to better match the image
  const sizeClasses = {
    sm: 'w-8 h-8', // Increased from w-6 for better visibility
    md: 'w-10 h-10',
    lg: 'w-12 h-12',
  };

  return (
    <Link to="/" className="flex items-center gap-2">
      <div className={`${sizeClasses[size]} rounded-full overflow-hidden border-2 border-ahavex-gold transition-transform duration-300 hover:scale-105`}>
        <img 
          src="/lovable-uploads/c706930b-e8bc-4fd4-8379-bf299d7f3c82.png" 
          alt="Ahavex Logo" 
          className="w-full h-full object-cover"
        />
      </div>
      {/* Hide text logo on mobile for cleaner look */}
      <span className="text-white font-bold tracking-wider text-lg hidden md:inline">AHAVEX</span>
    </Link>
  );
};

export default Logo;
